<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :show-close="true"
    @closed="closeDialog"
    v-dialogDrag
    width="760px"
  >
    <div class="pz_f_bd">
      <!-- <div class="pz_f_bd_close">
        <img src="@/assets/images/close_icon.png" @click="visible = false" />
      </div> -->
      <div class="pz_f_hd">
        <div class="pz_f_hdR">
          <video
            ref="videoCamera1"
            v-if="openSuccess1"
            id="videoCamera1"
            width="505"
            height="375"
            autoplay
            style="border: block; margin: 0 auto; display: block;"
          />
          <canvas
            id="canvasCamera1"
            style="display:none;"
            width="640"
            height="480"
          />
        </div>
      </div>
      <div class="pz_f_btnC">
        <a class="pz_f_btn" href="javascript:void(0);" @click="setImage()"
          >拍照</a
        >
      </div>
      <div class="zp1_con">
      <!-- <div> -->
        <span v-for="ans in ansList" :key="ans.url">
          <el-image
            :src="ans.url"
            :preview-src-list="[ans.url]"
            class="overflow:visible"
            title="点击查看大图"
          >
          </el-image>
          <div class="zp1_close" @click="removeTest(ans)"></div>
        </span>
      </div>
      <div></div>
    </div>
  </el-dialog>
</template>
<script>
// import { answerUpload } from "@/api/login";
import COS from "cos-js-sdk-v5";
// import Async from "async";
const cos = new COS({
  SecretId: "AKIDWpshESOHvGK9l9HyC8nCVdfeMp1xJ2Wk",
  SecretKey: "6zpPkpcPwwe5vBCyjESP5UcT2lEQr1Ok"
});

/**
 * 日期格式化
 * 这个函数接受两个参数，第一个参数是要格式化的日期时间，可以是 Date 对象或表示日期时间的字符串，第二个参数是要格式化的格式，例如 yyyy-MM-dd HH:mm:ss。该函数会将日期时间格式化为指定的格式，并返回格式化后的字符串。
 * 该函数使用了正则表达式来匹配格式字符串中的占位符，然后根据对应的日期时间值来替换占位符。其中，y 会被替换为年份，M、d、h、H、m、s、q、S、a、A 分别表示月份、日期、小时（12 小时制）、小时（24 小时制）、分钟、秒、季度、毫秒、上午/下午、AM/PM。
 * 使用该函数进行日期时间格式化的示例如下：
 * const date = new Date();
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss')); // 2023-02-16 08:25:05
 * console.log(formatDateTime(date, 'yyyy年MM月dd日 HH:mm:ss')); // 2023年02月16日 08:25:05
 * console.log(formatDateTime(date, 'yyyy-MM-dd HH:mm:ss S')); // 2023-02-16 08:25:05 950
 * console.log(formatDateTime(date, 'yyyy-MM-dd hh:mm:ss A')); // 2023-02-16 08:25:05 上午
 * 可以根据实际需要修改格式化的格式，以及支持更多的占位符和格式化选项。
 * @param date 
 * @param format 
 */
 function formatDateTime(date, format) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
    A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return format;
}
export default {
  props: ["imgSrc1"],
  data() {
    return {
      visible: false,
      faceBean: {
        fileBase64: "",
        extName: "",
        token: ""
      },
      descBean: {
        token: "",
        id: "1"
      },
      ansList: [],
      imgSrc: "",
      video1: null,
      context1: null,
      canvas1: null,
      openSuccess1: true,
      warnInfo: "",
      fileName: ""
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.openSuccess1 = true;
        this.imgSrc = "";
        setTimeout(() => {
          this.getCamera();
        }, 1000);
      } else {
        if (this.openSuccess1) {
          this.closeCamera();
        }
      }
    }
  },
  created() {
    setTimeout(() => {
      this.getCamera();
    }, 1000);
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    init(ansList) {
      if (ansList !== null) {
        this.ansList = ansList;
      }
      this.visible = true;
      this.faceBean.token = this.token;
      this.descBean.token = this.token;
      // sysDescById(this.descBean).then(res => {
      //   if (res.code === 200) {
      //     this.warnInfo = res.data.msg;
      //   }
      // });
    },
    // 打开摄像头
    getCamera() {
      this.openSuccess1 = true;
      this.video1 = document.getElementById("videoCamera1");
      this.canvas1 = document.getElementById("canvasCamera1");
      this.context1 = this.canvas1.getContext("2d");
      const errocb = () => {
        this.$message.error("摄像头打开失败！");
        this.openSuccess1 = false;
      };
      if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(
          { audio: false, video: true },
          stream => {
            // video.src=window.URL.createObjectURL(stream);
            this.video1.srcObject = stream;
            this.video1.play();
          },
          errocb
        );
      } else if (navigator.mediaDevices.getUserMedia) {
        // var constraints = { audio: true, video: { width: 1280, height: 720 } };
        const constraints = { audio: false, video: true };
        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          // var video = document.querySelector('video');
          this.video1.srcObject = stream;
          this.video1.onloadedmetadata = () => {
            this.video1.play();
          };
        });
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(
          { audio: false, video: true },
          stream => {
            this.video1.src = window.webkitURL.createObjectURL(stream);
            this.video1.srcObject = stream;
            this.video1.play();
          },
          errocb
        );
      } else {
        alert("你的浏览器不支持打开摄像头");
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      // alert(this.video1.videoWidth + "," + this.video1.videoHeight);
      this.context1.drawImage(
        this.video1,
        0,
        0,
        this.video1.videoWidth,
        this.video1.videoHeight
      );
      this.imgSrc = this.canvas1.toDataURL("image/png");
      // this.faceBean.extName = this.imgSrc.substring(
      //   this.imgSrc.indexOf("/") + 1,
      //   this.imgSrc.indexOf(";")
      // );
      // this.faceBean.fileBase64 = this.imgSrc.substring(22);
      // answerUpload(this.faceBean).then(res => {
      //   if (res.code === 200) {
      //     // this.$message.success("拍照成功");
      //     // this.visible = false;
      //     this.ansList.push(res.data);
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
      const fileBase64 = this.convertBase64UrlToBlob(this.imgSrc);
      this.selectFile(fileBase64);
    },
    removeTest(val) {
      this.ansList.forEach((item, index) => {
        if (item.url === val.url) {
          this.ansList.splice(index, 1);
        }
      });
    },
    // 关闭摄像头
    closeCamera() {
      this.video1.srcObject.getTracks()[0].stop();
      this.openSuccess1 = false;
    },
    // 关闭弹出层
    closeDialog() {
      this.closeCamera();
      this.visible = false;
      console.log(this.ansList);
      this.$emit("refreshData", this.ansList);
    },
    // 重写文件上传方法
    fileUpload(file) {
      this.fileToBase64(file.file)
        .then(res => {
          // console.log(res)
          this.imgSrc = res;
          this.dataForm.extName = res.substring(
            res.indexOf("/") + 1,
            res.indexOf(";")
          );
          const len = 19 + this.dataForm.extName.length;
          this.dataForm.fileBase64 = res.substring(len);
          // console.log(this.dataForm.fileBase64)
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err);
        });
    },
    // 转base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = "";
        if (file.size > 1024 * 1024 * 4) {
          reject("文件大小不能超过4M");
        }
        reader.readAsDataURL(file);
        // 开始转
        reader.onload = () => {
          fileResult = reader.result;
          // data:image/jpeg;base64,
        };
        // 转 失败
        reader.onerror = function(error) {
          reject(error);
        };
        // 转 结束  咱就 resolve 出去
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    },
    selectFile(baseData64) {
      console.log("data=" + baseData64);
      const that = this;
      this.uploadFile(baseData64, function(err, data) {
        if (data.statusCode === 200) {
          const uploadData = {
            name: that.fileName,
            url: "https://" + data.Location
          };
          console.log(uploadData);
          that.ansList.push(uploadData);
        } else {
          console.log(err);
          this.$message.error("上传文件失败。");
        }
      });
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte

      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }

      return new Blob([ab], { type: "image/png" });
    },
    // 上传文件
    uploadFile(fileBase64, callback) {
      const Bucket = "exam-1254560009";
      const Region = "ap-guangzhou";
      var mydate = new Date();
      // var uuid =
      //   "p" +
      //   mydate.getFullYear() +
      //   (mydate.getMonth() + 1) +
      //   (mydate.getDate() + 1) +
      //   mydate.getHours() +
      //   mydate.getMinutes() +
      //   mydate.getSeconds() +
      //   mydate.getMilliseconds() +
      //   (1000 + Math.round(Math.random() * 9998)) +
      //   ".png";

      var uuid = "p" + formatDateTime(mydate,"yyyyMMddHHmmssS") + (1000 + Math.round(Math.random() * 9998)) + ".png";
  
      this.fileName = uuid;
      // var Key = "https://exam-1254560009.cos.ap-guangzhou.myqcloud.com/answer/" + file.name; // 这里指定上传目录和文件名
      var Key = "answer/" + uuid; // 这里指定上传目录和文件名
      cos.putObject(
        {
          Bucket: Bucket /* 必须 */,
          Region: Region /* 存储桶所在地域，必须字段 */,
          Key: Key /* 必须 */,
          StorageClass: "STANDARD",
          Body: fileBase64, // 上传文件对象
          onProgress: function(progressData) {
            console.log(JSON.stringify(progressData));
          }
        },
        function(err, data) {
          console.log(err || data);
          callback(err, data);
        }
      );
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
